import * as types from "./actiontype";
import * as appActions from "../../../actions/appactions";
import dashboardService from "../services/dashboardservice";

export const initdashboard = () => {
  return async function (dispatch) {};
};

export const getUserDashboardEnd=(data)=>{
    return{
        type: types.GET_USER_DASHBOARD_END,
        payload: data,
    }
}
export const getDashboardDataEnd=(data)=>{
    return{
        type: types.GET_DASHBOARD_DATA_END,
        payload: data,
    }
}
export const updateDashboardAnalyticsParam=({name, value})=>{
  return{
      type: types.UPDATE_DASHBOARD_ANALYTICS_PARMS,
      payload: {name, value}
  }
}
export const resetParams=()=>{
  return{
    type: types.RESET_PARAMS
  }
}

export const getUserBranchEnd=(resp)=>{
  return {
      type: types.GET_USER_BRANCH_END,
      payload: resp
  }
}


export const getUserDashboard = () => {
  return async function (dispatch) {
    try {
      dispatch(appActions.setPreloading(true));
      var resp = await dashboardService.getUserDashboard();
      if(resp){
        dispatch(getUserDashboardEnd(resp));
      }
    } catch (e) {
      dispatch(appActions.handleError(e));
    } finally {
      dispatch(appActions.setPreloading(false));
    }
  };
};

export const getUserBranch=()=>{
  return async function (dispatch) {
    try {
      var resp = await dashboardService.getUserBranch();
      if (resp) {
        dispatch(getUserBranchEnd(resp));
      }
    } catch (e) {
      dispatch(appActions.handleError(e));
    }
  };
}
export const getDashboardData=(dashboardId)=>{
    return async function (dispatch, state) {
        let currentState = getState(state());
        let input = {
            DashboardId: dashboardId,
            FromDate: currentState.fromDate,
            ToDate: currentState.toDate,
            BranchId: currentState.branch ? parseFloat(currentState.branch) : 0,
            AgentIds: currentState.multipleSelectedValues.length > 0  ? currentState.multipleSelectedValues.map((val) => {
              return parseFloat(val.value)
            }) : null,
            SalesChannelId: currentState.salesChanelId ? parseFloat(currentState.salesChanelId) : 0,

          }
        try {
          dispatch(appActions.setPreloading(true));
          var resp = await dashboardService.getDashboardData(input);
          dispatch(getDashboardDataEnd(resp));
        } catch (e) {
          dispatch(appActions.handleError(e));
        } finally {
          dispatch(appActions.setPreloading(false));
        }
      };
}
const getState = (state) => {
    return state.dashboardReducer;
  };

  export const getAgentsList=()=>{
    return async function (dispatch,state) {
      let currentState = getState(state());
      try {
        let input = {

          salesChanelId: currentState.salesChanelId ? parseFloat(currentState.salesChanelId) : 0,

        }
        var resp = await dashboardService.getAgentsList(input);
        if (resp) {
          dispatch(getAgentsListEnd(resp));
        }
      } catch (e) {
        dispatch(appActions.handleError(e));
      }
    };
  }
  export const getAgentsListEnd=(resp)=>{
    return {
        type: types.GET_AGENT_LIST_END,
        payload: resp
    }
  }
  export const getSalesChannel=()=>{
    return async function (dispatch) {
      try {
        var resp = await dashboardService.getSalesChannel();
        if (resp) {
          dispatch(getSalesChannelEnd(resp));
        }
      } catch (e) {
        dispatch(appActions.handleError(e));
      }
    };
  }
  export const getSalesChannelEnd=(resp)=>{
    return {
        type: types.GET_SALE_CHANNEL_LIST_END,
        payload: resp
    }
  }
  export const CheckIfAgentOrBroker=()=>{
    return async function (dispatch) {
      try {
        var resp = await dashboardService.CheckIfAgentOrBroker();
        dispatch(updateDashboardAnalyticsParam({name: 'isAgentorBroker' ,value: resp}));
       
      } catch (e) {
        dispatch(appActions.handleError(e));
      }
    };
  }
  export const saveDropDownValues=(resp)=>{
    return {
        type: types.SAVE_DROPDOWN_VALUES_END,
        payload: resp
    }
  }
  export const setSelectedAgents = (selectedAgents) => ({
    type: types.SET_SELECTED_AGENTS,
    payload: selectedAgents,
  });